
import React, { useState } from 'react';
import { Clock, ChevronDown, ChevronUp, Settings } from 'lucide-react';
import DaypartActivityChart from './DaypartActivityChart';
import DaypartOpportunities from './DaypartOpportunities';
import DaypartPeakPeriods from './DaypartPeakPeriods';

const SegmentDaypartAnalysis = ({ segmentId }) => {
  const [showSettings, setShowSettings] = useState(false);
  const [expandedView, setExpandedView] = useState(false);
  
  return (
    <div className="bg-white rounded-lg shadow mb-6">
      <div className="border-b border-gray-200 p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center text-lg font-medium text-gray-900">
            <Clock size={20} className="mr-2 text-purple-600" />
            Daypart Activity Analysis
          </div>
          <div className="flex items-center space-x-2">
            <button 
              onClick={() => setShowSettings(!showSettings)}
              className="p-1.5 rounded-md hover:bg-gray-100 text-gray-500"
              title="Analysis Settings"
            >
              <Settings size={16} />
            </button>
            <button 
              onClick={() => setExpandedView(!expandedView)}
              className="px-2 py-1 flex items-center text-xs font-medium text-purple-700 bg-purple-50 rounded-md hover:bg-purple-100"
            >
              {expandedView ? (
                <>
                  <ChevronUp size={14} className="mr-1" />
                  Compact View
                </>
              ) : (
                <>
                  <ChevronDown size={14} className="mr-1" />
                  Expanded View
                </>
              )}
            </button>
          </div>
        </div>
        
        {showSettings && (
          <div className="mt-3 p-3 bg-gray-50 rounded-md grid grid-cols-3 gap-4 text-xs">
            <div>
              <label className="block text-gray-700 font-medium mb-1">Time Range</label>
              <select className="w-full border border-gray-300 rounded-md px-2 py-1">
                <option>Full Day (5AM-11PM)</option>
                <option>Morning (5AM-12PM)</option>
                <option>Afternoon (12PM-5PM)</option>
                <option>Evening (5PM-11PM)</option>
              </select>
            </div>
            <div>
              <label className="block text-gray-700 font-medium mb-1">Day Type</label>
              <select className="w-full border border-gray-300 rounded-md px-2 py-1">
                <option>All Days</option>
                <option>Weekdays</option>
                <option>Weekends</option>
              </select>
            </div>
            <div>
              <label className="block text-gray-700 font-medium mb-1">Metric</label>
              <select className="w-full border border-gray-300 rounded-md px-2 py-1">
                <option>Customer Traffic</option>
                <option>Sales Volume</option>
                <option>Transaction Count</option>
              </select>
            </div>
          </div>
        )}
      </div>
      
      <div className="p-4">
        {expandedView ? (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <DaypartActivityChart segmentId={segmentId} />
              <DaypartOpportunities segmentId={segmentId} />
            </div>
            <DaypartPeakPeriods segmentId={segmentId} />
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <DaypartActivityChart segmentId={segmentId} />
            <DaypartOpportunities segmentId={segmentId} />
          </div>
        )}
        
        {!expandedView && (
          <div className="mt-4 text-center">
            <button
              onClick={() => setExpandedView(true)}
              className="text-sm text-purple-700 hover:text-purple-900 font-medium inline-flex items-center"
            >
              <ChevronDown size={16} className="mr-1" />
              Show Detailed Analysis
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SegmentDaypartAnalysis;
